import React, { useState } from 'react';
import './HamburgerMenu.css';
import Modal from '../modal/Modal';
import CashCalendarDetails from '../ProjectDetails/CashCalendarDetails';
import CommunityApp from '../ProjectDetails/CommunityApp';
import ThirdEye from '../ProjectDetails/ThirdEye';

const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Skills', href: '#skills' },
  { label: 'Projects', href: '#projects' },
  { label: 'Contact', href: '#contact' },
];

const projectItems = [
  { label: 'Cash Calendar', component: CashCalendarDetails },
  { label: 'Community App', component: CommunityApp },
  { label: 'ThirdEye-Ra', component: ThirdEye },
];

const HamburgerMenu = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProjectsOpen, setIsProjectsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsProjectsOpen(false);
  };

  const openModal = (Component) => {
    setModalContent(<Component />);
    setIsModalOpen(true);
    closeMenu();
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent(null);
  };

  return (
    <>
      <header className="navbar">
        <a className="navbar-brand" href="#home" onClick={closeMenu}>
          <span className="navbar-logo">S</span>
          <span>Savas Erturk</span>
        </a>

        <button
          type="button"
          className={`navbar-toggle ${isMenuOpen ? 'is-open' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle navigation menu"
          aria-expanded={isMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`navbar-links ${isMenuOpen ? 'show' : ''}`}>
          {navLinks.map((link) => (
            <a key={link.href} href={link.href} onClick={closeMenu}>
              {link.label}
            </a>
          ))}

          <div className="navbar-projects">
            <button
              type="button"
              className="navbar-projects-button"
              onClick={() => setIsProjectsOpen(!isProjectsOpen)}
              aria-expanded={isProjectsOpen}
            >
              Project Details
            </button>
            {isProjectsOpen && (
              <div className="navbar-dropdown">
                {projectItems.map((item) => (
                  <button key={item.label} type="button" onClick={() => openModal(item.component)}>
                    {item.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </nav>
      </header>

      <Modal isOpen={isModalOpen} onClose={closeModal}>
        {modalContent}
      </Modal>
    </>
  );
};

export default HamburgerMenu;
